import CryptoJS from 'crypto-js';
const secretKey = 'key@123';

export function encryptData(data: any): string {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey);
    return encrypted?.toString();
}
export function decryptData(encryptedData: string): any {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes && JSON.parse(bytes?.toString(CryptoJS.enc.Utf8));
    return decryptedData;
}
export function storeData(storageKey: string, data: any, useSessionStorage: boolean = false): void {
    const storage = useSessionStorage ? sessionStorage : localStorage;
    const encryptedData = encryptData(data);
    storage.setItem(storageKey, encryptedData);

    // Announce sign-in / sign-out so features that care can react, without every login path having
    // to know about them. This is the ONE choke point all three paths share -- LoginForm,
    // GoogleLogin and KeycloakAuthHandler all record the session by writing `authToken` here, and
    // logout clears it the same way. src/consent/akkuConsent.ts listens, so the consent banner is
    // asked for after sign-in rather than on top of the login form.
    //
    // Dispatched as a DOM event rather than an import so this module stays a storage utility and
    // gains no dependency on the features that consume it.
    if (storageKey === 'authToken') {
        window.dispatchEvent(
            new CustomEvent('allaboard:auth-changed', { detail: { signedIn: Boolean(data) } }),
        );
    }
}
export function retrieveData(storageKey: string, useSessionStorage: boolean = false): any {
    const storage = useSessionStorage ? sessionStorage : localStorage;
    const encryptedData = storage.getItem(storageKey);
    if (encryptedData) {
        const decryptedData = decryptData(encryptedData);
        return decryptedData;
    } else {
        return null;
    }
}
